export default {
  dateInput: {
    placeholder: "дд/мм/рррр",
    openCalendar: "Відкрити календар",
    invalid: "Неправильна дата: використовуйте дд/мм/рррр",
  },
  myProfile: "Мій Профіль",
  billing: "Оплата",
  success: "Успіх",
  error: "Помилка",
  ok: "OK",
  validationSaveFailedTitle: "Помилка валідації",
  validationSaveFailedIntro:
    "Запис не вдалося зберегти з таких причин:",
  validationSaveAnyway: "Зберегти все одно",
  validationUnderstood: "OK",
  expenseFileMissingTitle: "Related File не додано",
  expenseFileMissingText:
    "Ви зберігаєте без доданого Related File. Продовжити все одно?",
  expenseFileMissingCancel: "Скасувати",
  validationPendingAmountToApply: "У вас залишився нерозподілений залишок",
  contactOutsideOperationTitle: "Контакт поза операцією",
  shippingIncoherenceTitle: "Невідповідності в цьому відвантаженні",
  contactOutsideOperationText:
    "{contact} не бере участі в {operations}: це не клієнт, не постачальник і не контакт жодної витрати. Якщо платить або отримує третя сторона — це нормально; інакше перевірте контакт.",
  contactOutsideOperationCancel: "Перевірити",
  contactOutsideOperationBanner:
    "Цей запис застосовано до {operations}, але {contact} не бере участі в цій операції (не клієнт, не постачальник і не контакт жодної витрати). Перевірте, чи правильний контакт.",
  collectContactNotClientTitle: "Надходження не від клієнта",
  collectContactNotClientText:
    "{contact} не є клієнтом {operations}. Якщо за клієнта платить третя сторона — це нормально; інакше перевірте контакт.",
  collectContactNotClientBanner:
    "Це надходження застосовано до {operations}, але {contact} не є клієнтом цієї операції. Перевірте, чи правильний контакт.",
  validationForceSaveSessionTitle: "Сесію завершено",
  validationForceSaveSessionText:
    "Не вдалося зберегти, бо сесія закінчилася. Оновіть сторінку або увійдіть знову й повторіть спробу.",
  validationForceSaveGenericText:
    "Не вдалося завершити примусове збереження. Перевірте з’єднання й спробуйте знову.",
  routerNavLoading: "Завантаження…",
  testEnvironmentBanner: "Тестова версія — локальне середовище",
  testEnvironmentBannerHosted:
    "Тестова версія — ви переглядаєте тестову копію (це не продакшн)",
  "systemFeaturesPermissionDeniedTitle": "Немає дозволу",
  "systemFeaturesPermissionDeniedText":
    "У вас немає дозволу вмикати або вимикати функції системи. Попросіть адміністратора надати «Access system features» (systemfeatures.access) для вашої ролі.",
  registerSuccessLogin: "Обліковий запис створено. Тепер можна увійти.",
  registerConfirmEmailSent:
    "Ми надіслали посилання на вашу електронну пошту ({email}) для підтвердження облікового запису. Якщо ви його не отримали, перевірте папку «Спам». Натисніть на посилання, щоб підтвердити обліковий запис.",
  forgotPassword: "Забули пароль?",
  getStarted: "Почати",

  // Register.vue (кореневі ключі для $t)
  name: "Ім'я",
  email: "Електронна пошта",
  password: "Пароль",
  businessName: "Назва бізнесу",
  login: "Увійти",
  confirmEmailText: "Перевірте пошту, щоб підтвердити обліковий запис",
  nameAlreadyTaken: "Ця назва вже зайнята",
  errorCheckingRestaurantName: "Не вдалося перевірити доступність назви",
  nameRequired: "Ім'я обов'язкове",
  countryRequired: "Країна обов'язкова",
  restaurantNameRequired: "Назва бізнесу обов'язкова",
  emailRequired: "Електронна пошта обов'язкова",
  emailInvalid: "Некоректна адреса електронної пошти",
  passwordRequired: "Пароль обов'язковий",
  userExists: "Обліковий запис із цією поштою вже існує",
  registerCompanyLinkPlaceholder: "Посилання на ваш бізнес (необов'язково)",
  registerHelpBusinessUrl:
    "Ми використовуємо назву вашого бізнесу в URL, за яким клієнти заходять у застосунок.",
  registerHelpDedicatedDbConfirm:
    "Після підтвердження електронної пошти буде створено окрему базу даних для вашого бізнесу (той самий користувач на цій інстанції та на новій).",
  registerHelpDedicatedDbImmediate:
    "Окрема база даних для вашого бізнесу створюється одразу (той самий користувач на цій інстанції та на новій).",
  registerHelpCompanyLink:
    "Вкажіть посилання на Instagram, Facebook або сайт, щоб ми могли згадувати вас у маркетингових кампаніях.",
  registerHelpEmailConfirmBusiness:
    "Ми надішлемо лист із посиланням для підтвердження облікового запису; база даних бізнесу створюється після підтвердження.",
  registerHelpEmailConfirmAny:
    "Ми надішлемо лист із посиланням для підтвердження облікового запису; увійти можна лише після підтвердження.",
  registerConfirmSpamP1:
    "Якщо не бачите листа, перевірте спам. Якщо не отримали повідомлення з кодом, зв'яжіться з нами для ручної активації. Напишіть на contact@gotake.it або у WhatsApp технічної підтримки, натисніть тут:",
  registerConfirmWhatsapp: "WhatsApp",

  nothingtosee: "Нічого не знайдено",
  logout: "Вийти",

  "Add new": "Додати новий",
  All: "Всі",

  // Tutorial translations
  tutorial: {
    // Welcome step
    welcome: {
      title: "Ласкаво просимо до Підручника LawAI",
      description:
        "Я проведу вас через всі функції динамічного екрану списку. Ви навчитеся використовувати фільтри, стовпці, пошук та багато іншого.",
      details: [
        "Цей підручник покаже вам покроково, як працює кожна функція",
        "Ви можете навігувати за допомогою кнопок або натискати на індикатори",
        "В кінці ви зможете використовувати всі інструменти як експерт",
      ],

      tip: "Візьміть час, щоб зрозуміти кожну функцію. Не хвилюйтеся, якщо ви не пам'ятаєте все, ви завжди можете переглянути цей підручник.",
    },

    // Search step
    search: {
      title: "Пошук за Ключовими Словами",
      description:
        "Поле пошуку дозволяє швидко знаходити записи, вводячи будь-який текст, що містить інформацію, яку ви шукаєте.",
      details: [
        "Введіть будь-яке слово або фразу для пошуку",
        "Пошук виконується у всіх видимих полях",
        "Результати фільтруються в реальному часі",
        "Ви можете очистити пошук кнопкою X",
      ],

      tip: "Використовуйте конкретні слова для отримання більш точних результатів. Наприклад, якщо ви шукаєте \"Іван\", з'являться всі записи, що містять це ім'я.",
    },

    // Column preferences step
    columnPreferences: {
      title: "Налаштування Стовпців",
      description:
        "Кнопка стовпців дозволяє повністю налаштувати, які поля ви хочете бачити у вашій таблиці та як їх організувати.",
      details: [
        "Натисніть на кнопку з іконкою стовпців, щоб відкрити селектор",
        "Відмітьте/зніміть позначки з полів, щоб показати або приховати їх",
        "Перетягуйте та опускайте для зміни порядку стовпців",
        "Зміни автоматично зберігаються у ваших налаштуваннях",
        "Ви можете групувати пов'язані поля для кращої організації",
      ],

      tip: "Спочатку організуйте найважливіші стовпці для більш ефективного перегляду ваших даних. Налаштування зберігаються для кожного користувача та моделі.",
    },

    // Filter preferences step
    filterPreferences: {
      title: "Налаштування Фільтрів",
      description:
        "Кнопка фільтрів дозволяє налаштувати, які поля будуть доступні для фільтрації та персоналізувати ваш досвід фільтрації.",
      details: [
        "Натисніть на кнопку з іконкою фільтра, щоб відкрити селектор",
        "Виберіть, які поля ви хочете зробити доступними для фільтрації",
        'Ви можете відмічати/знімати позначки з окремих полів або використовувати "Вибрати всі"',
        "Вибрані поля з'являться як кнопки фільтрів",
        "Налаштування автоматично зберігаються для кожного користувача та моделі",
      ],

      tip: "Виберіть тільки ті поля, які ви дійсно потрібно фільтрувати, щоб зберегти інтерфейс чистим та зосередженим на важливому.",
    },

    // Filter usage step
    filterUsage: {
      title: "Використання Налаштованих Фільтрів",
      description:
        "Після налаштування ваших уподобань фільтри з'являються як кнопки, які ви можете використовувати для уточнення ваших результатів.",
      details: [
        "Сині фільтри застосовані та активно фільтрують ваші дані",
        "Сірі фільтри доступні для використання, коли потрібно",
        "Натисніть на будь-який фільтр для налаштування його конкретних критеріїв",
        'Ви можете розгорнути, щоб побачити більше опцій кнопкою "+ фільтри"',
        "Комбінуйте кілька фільтрів для більш точних результатів",
      ],

      tip: "Зберігайте тільки ті фільтри, які ви дійсно потрібно, щоб не ускладнювати ваш перегляд даних. Фільтри можна очистити окремо або всі одразу.",
    },

    // Column sorting step
    columnSorting: {
      title: "Сортування Стовпців",
      description:
        "Натисніть на заголовки стовпців для сортування даних за зростанням або спаданням.",
      details: [
        "Натисніть на заголовок для сортування за зростанням",
        "Натисніть ще раз для сортування за спаданням",
        "Стовпці, що сортуються, показують іконку стрілки",
        "Поточний порядок зберігається, поки ви не зміните перегляд",
      ],

      tip: "Комбінуйте сортування з фільтрами для швидкого пошуку найбільш релевантних записів.",
    },

    // Individual column management step
    individualColumns: {
      title: "Управління Окремими Стовпцями",
      description:
        "Кожен стовпець має окремі опції, такі як приховування, зміна порядку та персоналізація.",
      details: [
        "Використовуйте кнопку X на кожному стовпці, щоб приховати його",
        "Перетягуйте та опускайте заголовки для зміни порядку",
        "Приховані стовпці можна відновити з селектора",
        "Зміни застосовуються негайно",
      ],

      tip: "Приховуйте стовпці, які ви не використовуєте часто, щоб мати більш чистий та зосереджений перегляд.",
    },

    // Preferences system step
    preferencesSystem: {
      title: "Система Налаштувань",
      description:
        "Всі ваші конфігурації стовпців та фільтрів автоматично зберігаються та завантажуються кожного разу, коли ви отримуєте доступ до моделі.",
      details: [
        "Налаштування стовпців зберігаються для кожного користувача та моделі",
        "Налаштування фільтрів автоматично зберігаються",
        "При зміні моделі завантажуються конкретні налаштування",
        "Ви можете скинути налаштування з селектора стовпців",
        "Зміни синхронізуються в реальному часі",
      ],

      tip: "Ваші налаштування зберігаються між сесіями, тому вам не доведеться налаштовувати все знову кожного разу, коли ви отримуєте доступ.",
    },

    // Report views step
    reportViews: {
      title: "Перегляди Звітів",
      description:
        "Отримайте доступ до різних типів звітів та персоналізованих переглядів для аналізу ваших даних.",
      details: [
        "Кожна кнопка звіту відкриває інший перегляд",
        "Звіти можуть показувати згруповані або підсумовані дані",
        "Ви можете експортувати результати у різних форматах",
        "Перегляди зберігаються та завжди доступні",
      ],

      tip: "Використовуйте різні перегляди звітів для аналізу ваших даних з кількох перспектив.",
    },

    // Bulk actions step
    bulkActions: {
      title: "Масові Дії",
      description: "Виконуйте операції з кількома вибраними записами одразу.",
      details: [
        'Виберіть окремі записи або використовуйте "Вибрати всі"',
        "Виконуйте масове редагування загальних полів",
        "Видаляйте кілька записів одразу",
        "Масові дії економлять час на повторюваних операціях",
      ],

      tip: "Масові дії ідеальні для оновлення станів, категорій або будь-якого поля, що є загальним для кількох записів.",
    },

    // Completion step
    completion: {
      title: "Підручник Завершено!",
      description:
        "Вітаємо! Тепер ви знаєте всі основні функції динамічного екрану списку.",
      details: [
        "Ви можете налаштувати уподобання стовпців та фільтрів",
        "Ефективно шукати та фільтрувати дані",
        "Персоналізувати стовпці відповідно до ваших потреб",
        "Сортувати та організовувати інформацію",
        "Отримувати доступ до спеціалізованих звітів та переглядів",
        "Виконувати масові дії, коли необхідно",
      ],

      tip: "Практикуйтеся з цими функціями, щоб ознайомитися. Пам'ятайте, що ви завжди можете переглянути цей підручник з меню довідки.",
    },

    // Navigation buttons
    navigation: {
      previous: "Попередній",
      next: "Наступний",
      complete: "Завершити",
      exit: "Вийти",
    },

    // Progress
    progress: "з",

    // Tip label
    tipLabel: "Порада:",
  },

  // Operations Summary translations
  operationsSummary: {
    title: "Резюме Операцій",
    noOperations: "Немає майбутніх операцій",
    help: "Допомога щодо дат експорту",
    close: "Закрити",
    helpText: {
      title: "Критерії Класифікації",
      sections: {
        mainDates: {
          title: "Основні Дати Відвантаження",
          eta: "ETA (Estimated Time of Arrival): Очікувана дата прибуття судна/літака до порту призначення. Важливо для координації митного оформлення та отримання вантажу.",
          etd: "ETD (Estimated Time of Departure): Очікувана дата відправлення судна/літака з порту відправлення. Позначає початок міжнародного транзиту.",
        },
        cutOffs: {
          title: "Cut Offs (Закриття)",
          documents:
            "Cut Off Documents: Крайній термін подання експортної документації. Якщо не дотримано, відвантаження може бути виключено з рейсу.",
          physical:
            "Cut Off Physical: Крайній термін фізичної доставки вантажу до терміналу. Після цієї точки контейнер більше не може бути прийнятий.",
        },
        cargoMovements: {
          title: "Рухи Вантажу",
          loading:
            "Loading Date: День, коли вантаж завантажується на судно/літак. Збігається з операціями стивування в порту.",
          gateOut:
            "Gate Out: Дата, коли контейнер виходить зі складу до портового терміналу. Позначає початок зберігання перевізником.",
        },
        documentation: {
          title: "Комерційна Документація",
          dateReleased:
            "Date Released: Дата звільнення документів відвантаження. З цього моменту імпортер може керувати отриманням у пункті призначення.",
        },
        importPermits: {
          title: "Дозволи на Імпорт",
          expiration:
            "Import Permit Expiration: Дата закінчення дозволу. Якщо він закінчується до прибуття вантажу, він не може бути націоналізований.",
        },
        payments: {
          title: "Дати Платежів",
          paymentDate:
            "Payment Date: Дата, коли щось потрібно сплатити. Критично важливо для підтримки грошового потоку та уникнення штрафів.",
        },
      },
    },
    messages: {
      eta: {
        today:
          "🚢 <strong>Прибуття сьогодні!</strong> {count} {vessel} {verb} сьогодні до порту призначення. Час координувати митне оформлення та отримання вантажу.",
        tomorrow:
          "🚢 <strong>Прибуття завтра:</strong> {count} {vessel} {verb} завтра. Підготуйтеся до митного оформлення.",
        thisWeek:
          "🚢 <strong>Цього тижня:</strong> {count} {vessel} {verb} цього тижня. Координуйте з імпортером для отримання.",
      },
      etd: {
        today:
          "⚓ <strong>Відправлення сьогодні:</strong> {count} {vessel} {verb} сьогодні з порту відправлення. Міжнародний транзит розпочався.",
        tomorrow:
          "⚓ <strong>Відправлення завтра:</strong> {count} {vessel} {verb} завтра. Остання можливість завершити документацію.",
        thisWeek:
          "⚓ <strong>Цього тижня:</strong> {count} {vessel} {verb} цього тижня з порту відправлення.",
      },
      loading: {
        today:
          "📦 <strong>Завантаження сьогодні:</strong> {count} {container} {verb} сьогодні на судно. Операції стивування в порту.",
        tomorrow:
          "📦 <strong>Завантаження завтра:</strong> {count} {container} {verb} завтра.",
        thisWeek:
          "📦 <strong>Цього тижня:</strong> {count} {container} {verb} цього тижня.",
      },
      gateOut: {
        today:
          "🚛 <strong>Gate Out сьогодні:</strong> {count} {container} {verb} сьогодні зі складу до портового терміналу.",
        tomorrow:
          "🚛 <strong>Gate Out завтра:</strong> {count} {container} {verb} завтра до порту.",
        thisWeek:
          "🚛 <strong>Цього тижня:</strong> {count} {container} {verb} цього тижня до терміналу.",
      },
      payment: {
        today:
          "💰 <strong>Платіж сьогодні:</strong> {count} {payment} {verb} сьогодні. Увага! Перевірте статус очікуючих платежів.",
        tomorrow:
          "💰 <strong>Платіж завтра:</strong> {count} {payment} {verb} завтра. Підготуйтеся до здійснення платежів.",
        thisWeek:
          "💰 <strong>Цього тижня:</strong> {count} {payment} {verb} цього тижня.",
      },
      cutOffDocs: {
        today:
          "📄 <strong>Cut Off документів сьогодні:</strong> {count} {operation} {verb} закриття документів сьогодні. Остання можливість!",
        tomorrow:
          "📄 <strong>Cut Off документів завтра:</strong> {count} {operation} {verb} закриття документів завтра.",
        thisWeek:
          "📄 <strong>Цього тижня:</strong> {count} {operation} {verb} закриття документів цього тижня.",
      },
      cutOffPhysical: {
        today:
          "📦 <strong>Cut Off фізичний сьогодні:</strong> {count} {operation} {verb} фізичне закриття сьогодні. Остання можливість!",
        tomorrow:
          "📦 <strong>Cut Off фізичний завтра:</strong> {count} {operation} {verb} фізичне закриття завтра.",
        thisWeek:
          "📦 <strong>Цього тижня:</strong> {count} {operation} {verb} фізичне закриття цього тижня.",
      },
      dateReleased: {
        today:
          "📋 <strong>Документи звільнені сьогодні:</strong> {count} {document} {verb} сьогодні. Імпортер може керувати отриманням.",
        tomorrow:
          "📋 <strong>Документи завтра:</strong> {count} {document} {verb} завтра.",
        thisWeek:
          "📋 <strong>Цього тижня:</strong> {count} {document} {verb} цього тижня.",
      },
      importPermit: {
        today:
          "🛂 <strong>Дозволи закінчуються сьогодні:</strong> {count} {permit} {verb} сьогодні. Критично! Без дозволу не може бути націоналізований.",
        tomorrow:
          "🛂 <strong>Дозволи завтра:</strong> {count} {permit} {verb} завтра. Терміново поновіть.",
        thisWeek:
          "🛂 <strong>Цього тижня:</strong> {count} {permit} {verb} цього тижня.",
      },
    },
    words: {
      vessel: { single: "судно", plural: "судна" },
      container: { single: "контейнер", plural: "контейнери" },
      payment: { single: "платіж", plural: "платежі" },
      operation: { single: "операція", plural: "операції" },
      document: { single: "набір документів", plural: "набори документів" },
      permit: { single: "дозвіл", plural: "дозволи" },
      arrives: { single: "прибуває", plural: "прибувають" },
      leaves: { single: "відправляється", plural: "відправляються" },
      loads: { single: "завантажується", plural: "завантажуються" },
      goesOut: { single: "виходить", plural: "виходять" },
      expires: { single: "закінчується", plural: "закінчуються" },
      has: { single: "має", plural: "мають" },
      releases: { single: "звільняється", plural: "звільняються" },
    },
  },

  // Events Analyzer translations
  eventsAnalyzer: {
    pendingPayment: "Очікує оплати",
    viewDetails: "Переглянути деталі",
  },

  listTitleHidden: "Приховані",
  "Export to Excel": "Експорт у Excel",
  "Hide empty date": "Приховати без дати",
  "Actions": "Дії",
  "Debit": "Дебет",
  "Credit": "Кредит",
  "Attached File": "Прикріплений файл",
  "No transactions found matching your search": "Немає рухів, що відповідають пошуку",
  "Hide movements that have no date": "Приховати рухи без дати",
  "No payments found": "Платежів не знайдено",
  "No collects found": "Надходжень не знайдено",
  listTabActive: "Активні",
  listTabArchived: "Архівовані",
  listTabAll: "Усі",
  hide: "Приховати",
  hideInThisView: "Приховати в цьому вигляді",
  showInThisView: "Показати в цьому вигляді",
  HideSelected: "Приховати вибрані",
  ShowSelected: "Показати вибрані",

  treeEdit: {
    dragToMove: "Перетягніть, щоб перемістити",
    elementName: "Назва елемента",
    editElement: "Редагувати елемент",
    deleteElement: "Видалити цей елемент",

    accountingCode: "Бухгалтерський код для проводок",
    itemColor: "Колір елемента",
    itemColorHint:
      "Колір використовується як тло позначки, коли цей елемент з'являється у списку. Без кольору він показується сірим.",
    noColor: "Без кольору",
    listTranslationsSection: "Переклади за мовами (необов’язково)",
    listTranslationsHint:
      "Якщо заповнити мову, користувачі побачать цей текст у відповідній мові інтерфейсу. Залиште порожнім, щоб використовувати назву вище.",
  },
};
